// buildDefaultFormDate — pure computation of the form's default "today" date.
//
// Extracted verbatim from `FlightLookup.js` (the IIFE used to initialize
// `lookupForm.date` when no `defaultDate` prop is supplied) as part of the
// behavior-preserving refactor (issue #240). The source read the wall-clock via
// `new Date()` and formatted the LOCAL year/month/day as `YYYY-MM-DD`; that read
// is injected here through the `now` parameter (defaulting to `new Date()`) so
// the function stays pure while preserving identical call-site behavior.
//
// This is exactly `formatDateStr(now)`; it is kept as a named helper because the
// container uses it as the `defaultDate ||` fallback for the date field. The
// `defaultDate ||` choice itself remains in the container (rewired in 9.7).
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

import formatDateStr from './formatDateStr.js';

/**
 * Computes the default `YYYY-MM-DD` date (today, local time) for the lookup form.
 *
 * @param {Date} [now=new Date()] - The reference "now".
 * @returns {string} Today's date as a local `YYYY-MM-DD` string.
 */
export function buildDefaultFormDate(now = new Date()) {
  // Use local date instead of UTC date for the form
  return formatDateStr(now);
}

export default buildDefaultFormDate;
